var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShotDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 81,
    viewBox: "0 0 56 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1502 8.48263L41.3307 8.06664C47.3547 15.7339 40.3051 37.1114 40.3051 37.1114L39.7159 38.5376C40.9785 38.8006 41.7839 38.8091 41.9178 38.5005L41.9221 38.4338L41.9428 38.4428C45.0191 31.3254 46.8536 22.9942 46.8536 22.9942C49.0525 7.72957 42.9277 5.62828 42.9277 5.62828L42.9218 5.62572C42.7489 5.52677 42.5721 5.43444 42.3893 5.35515C41.2739 4.87126 40.0349 4.80473 38.7263 5.09548C29.0745 6.8674 19.851 27.4795 19.34 28.637L19.3601 28.6457L19.3149 28.6947C18.9485 29.5393 23.7108 32.421 29.9509 35.1282C32.6471 36.2978 35.1753 37.2416 37.2095 37.8709C46.1379 13.8105 41.1502 8.48263 41.1502 8.48263Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2051 72.7601C22.4487 76.3364 25.8616 75.5108 25.8616 75.5108L41.6572 39.1011C41.6572 39.1011 41.2298 39.4431 39.4521 39.1738L25.2079 73.532L22.1664 72.7738L36.5737 39.5642C36.703 39.2309 36.8187 38.9144 36.9424 38.5879C35.5137 38.1706 33.6746 37.5156 31.3027 36.5057C31.3027 36.5057 20.9079 32.4684 18.9328 29.5755L3.25875 65.705C3.72859 67.2903 5.96176 69.1839 14.2051 72.7601Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7076 77.9234C25.5688 78.2105 26.4011 78.0407 26.7499 77.713L26.8045 77.6579C26.9369 77.5026 26.9944 77.3216 27.103 77.1359C27.199 76.7793 27.1067 76.3974 26.7275 76.163L26.684 76.1406C26.3012 76.032 25.8576 75.9938 25.6349 76.0331C25.6349 76.0331 22.5081 76.6904 15.872 74.0241C9.23373 71.3547 5.74333 69.9304 3.03205 66.2273C3.03205 66.2273 2.39164 64.7919 1.61392 65.6121C0.835275 66.4344 3.05428 69.8168 6.88858 71.9031C10.7246 73.987 17.9645 77.4439 22.7076 77.9234Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7159 38.5373C39.0115 38.3925 38.1687 38.1674 37.2094 37.8706C37.1228 38.1063 37.0328 38.3475 36.9424 38.5874C37.9836 38.8917 38.8076 39.0748 39.4521 39.1732L39.7159 38.5373Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1502 8.48263L41.3307 8.06664C47.3547 15.7339 40.3051 37.1114 40.3051 37.1114L39.7159 38.5376C40.9785 38.8006 41.7839 38.8091 41.9178 38.5005L41.9221 38.4338L41.9428 38.4428C45.0191 31.3254 46.8536 22.9942 46.8536 22.9942C49.0525 7.72957 42.9277 5.62828 42.9277 5.62828L42.9218 5.62572C42.7489 5.52677 42.5721 5.43444 42.3893 5.35515C41.2739 4.87126 40.0349 4.80473 38.7263 5.09548C29.0745 6.8674 19.851 27.4795 19.34 28.637L19.3601 28.6457L19.3149 28.6947C18.9485 29.5393 23.7108 32.421 29.9509 35.1282C32.6471 36.2978 35.1753 37.2416 37.2095 37.8709C46.1379 13.8105 41.1502 8.48263 41.1502 8.48263Z",
    fill: "#C7C7C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2051 72.7601C22.4487 76.3364 25.8616 75.5108 25.8616 75.5108L41.6572 39.1011C41.6572 39.1011 41.2298 39.4431 39.4521 39.1738L25.2079 73.532L22.1664 72.7738L36.5737 39.5642C36.703 39.2309 36.8187 38.9144 36.9424 38.5879C35.5137 38.1706 33.6746 37.5156 31.3027 36.5057C31.3027 36.5057 20.9079 32.4684 18.9328 29.5755L3.25875 65.705C3.72859 67.2903 5.96176 69.1839 14.2051 72.7601Z",
    fill: "#C7C7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7076 77.9234C25.5688 78.2105 26.4011 78.0407 26.7499 77.713L26.8045 77.6579C26.9369 77.5026 26.9944 77.3216 27.103 77.1359C27.199 76.7793 27.1067 76.3974 26.7275 76.163L26.684 76.1406C26.3012 76.032 25.8576 75.9938 25.6349 76.0331C25.6349 76.0331 22.5081 76.6904 15.872 74.0241C9.23373 71.3547 5.74333 69.9304 3.03205 66.2273C3.03205 66.2273 2.39164 64.7919 1.61392 65.6121C0.835275 66.4344 3.05428 69.8168 6.88858 71.9031C10.7246 73.987 17.9645 77.4439 22.7076 77.9234Z",
    fill: "#C7C7C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7159 38.5373C39.0115 38.3925 38.1687 38.1674 37.2094 37.8706C37.1228 38.1063 37.0328 38.3475 36.9424 38.5874C37.9836 38.8917 38.8076 39.0748 39.4521 39.1732L39.7159 38.5373Z",
    fill: "#C7C7C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 45.2482,
    y1: 24.18,
    x2: 12.8876,
    y2: 10.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 30.9127,
    y1: 57.2241,
    x2: -1.44793,
    y2: 43.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 23.8173,
    y1: 77.1594,
    x2: -12.9588,
    y2: 61.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 39.2437,
    y1: 38.9591,
    x2: 35.8604,
    y2: 37.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotDisable);
export default __webpack_public_path__ + "static/media/shot_disable.7bdc9889b2c92614309ae6e68eaaeecf.svg";
export { ForwardRef as ReactComponent };